import language from './en.json'

export const ALERT_TYPES = {
  office365_leaked_credentials: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_LEAKED_CREDENTIALS'],
  },
  office365_azure_ad_threat_intelligence: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_AZURE_AD_THREAT_INTELLIGENCE'],
  },
  office365_anonymous_ip_address: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ANONYMOUS_IP_ADDRESS'],
  },
  office365_atypical_travel: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ATYPICAL_TRAVEL'],
  },
  office365_anomalous_token: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ANOMALOUS_TOKEN'],
  },
  office365_token_issuer_anomaly: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_TOKEN_ISSUER_ANOMALY'],
  },
  office365_suspicious_browser: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SUSPICIOUS_BROWSER'],
  },
  office365_unfamiliar_signin_properties: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UNFAMILIAR_SIGNIN_PROPERTIES'],
  },
  google_anonymous_ip_address: {
    message: language['THREAT_ALERTS.ALERT_TYPE.GOOGLE_ANONYMOUS_IP_ADDRESS'],
  },
  google_leaked_credentials: {
    message: language['THREAT_ALERTS.ALERT_TYPE.GOOGLE_LEAKED_CREDENTIALS'],
  },
  office365_admin_confirmed_user_compromised: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ADMIN_CONFIRMED_USER_COMPROMISED'],
  },
  office365_malicious_ip_address: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MALICIOUS_IP_ADDRESS'],
  },
  office365_suspicious_inbox_manipulation_rules: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SUSPICIOUS_INBOX_MANIPULATION_RULES'],
  },
  office365_password_spray: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_PASSWORD_SPRAY'],
  },
  office365_impossible_travel: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_IMPOSSIBLE_TRAVEL'],
  },
  office365_new_country: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_NEW_COUNTRY'],
  },
  office365_activity_from_anonymous_ip_address: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ACTIVITY_FROM_ANONYMOUS_IP_ADDRESS'],
  },
  office365_suspicious_inbox_forwarding: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SUSPICIOUS_INBOX_FORWARDING'],
  },
  office365_additional_risk_detected: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ADDITIONAL_RISK_DETECTED'],
  },
  office365_activities_from_suspicious_user_agents: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ACTIVITIES_FROM_SUSPICIOUS_USER_AGENTS'],
  },
  office365_activity_from_a_tor_ip_address: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ACTIVITY_FROM_A_TOR_IP_ADDRESS'],
  },
  office365_activity_from_infrequent_country: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ACTIVITY_FROM_INFREQUENT_COUNTRY'],
  },
  office365_admin_submission_result_completed: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ADMIN_SUBMISSION_RESULT_COMPLETED'],
  },
  office365_admin_triggered_manual_investigation_of_email: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ADMIN_TRIGGERED_MANUAL_INVESTIGATION_OF_EMAIL'],
  },
  office365_admin_triggered_user_compromise_investigation: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ADMIN_TRIGGERED_USER_COMPROMISE_INVESTIGATION'],
  },
  office365_block_sharepoint_file_download: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_BLOCK_SHAREPOINT_FILE_DOWNLOAD'],
  },
  office365_creation_of_forwardingredirect_rule: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_CREATION_OF_FORWARDINGREDIRECT_RULE'],
  },
  office365_dlphigh_volume_of_content_detected_us_financial_data: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DLPHIGH_VOLUME_OF_CONTENT_DETECTED_US_FINANCIAL_DATA'],
  },
  office365_dlplow_volume_of_content_detected_us_pii: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DLPLOW_VOLUME_OF_CONTENT_DETECTED_US_PII'],
  },
  office365_dlpuk_pii_scan_content_shared_outside__low_count: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DLPUK_PII_SCAN_CONTENT_SHARED_OUTSIDE__LOW_COUNT'],
  },
  office365_ediscovery_search_started_or_exported: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EDISCOVERY_SEARCH_STARTED_OR_EXPORTED'],
  },
  office365_email_messages_containing_malicious_file_removed_after_delivery: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EMAIL_MESSAGES_CONTAINING_MALICIOUS_FILE_REMOVED_AFTER_DELIVERY'],
  },
  office365_email_messages_containing_malicious_url_removed_after_delivery: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EMAIL_MESSAGES_CONTAINING_MALICIOUS_URL_REMOVED_AFTER_DELIVERY'],
  },
  office365_email_messages_from_a_campaign_removed_after_delivery: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EMAIL_MESSAGES_FROM_A_CAMPAIGN_REMOVED_AFTER_DELIVERY'],
  },
  office365_email_reported_by_user_as_malware_or_phish: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EMAIL_REPORTED_BY_USER_AS_MALWARE_OR_PHISH'],
  },
  office365_email_sending_limit_exceeded: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EMAIL_SENDING_LIMIT_EXCEEDED'],
  },
  office365_honeytoken_activity: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_HONEYTOKEN_ACTIVITY'],
  },
  office365_impossible_travel_activity: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_IMPOSSIBLE_TRAVEL_ACTIVITY'],
  },
  office365_mail_forward_rule_enabled: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MAIL_FORWARD_RULE_ENABLED'],
  },
  office365_mailbox_permissions_change: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MAILBOX_PERMISSIONS_CHANGE'],
  },
  office365_malware_detection: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MALWARE_DETECTION'],
  },
  office365_mass_download: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MASS_DOWNLOAD'],
  },
  office365_mass_download_by_a_single_user: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MASS_DOWNLOAD_BY_A_SINGLE_USER'],
  },
  office365_multiple_failed_user_logon_attempts_to_a_service: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MULTIPLE_FAILED_USER_LOGON_ATTEMPTS_TO_A_SERVICE'],
  },
  office365_new_app_detected_in_organization: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_NEW_APP_DETECTED_IN_ORGANIZATION'],
  },
  office365_new_app_with_score_04: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_NEW_APP_WITH_SCORE_04'],
  },
  office365_new_popular_app: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_NEW_POPULAR_APP'],
  },
  office365_oauthcreation: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_OAUTHCREATION'],
  },
  office365_distributed_password_cracking_attempts_in_azuread: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DISTRIBUTED_PASSWORD_CRACKING_ATTEMPTS_IN_AZUREAD'],
  },
  office365_explicit_mfa_deny: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EXPLICIT_MFA_DENY'],
  },
  office365_brute_force_attack_against_azure_portal: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_BRUTE_FORCE_ATTACK_AGAINST_AZURE_PORTAL'],
  },
  office365_multiple_password_reset_by_user: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MULTIPLE_PASSWORD_RESET_BY_USER'],
  },
  office365_permission_changes: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_PERMISSION_CHANGES'],
  },
  office365_phish_delivered_due_to_an_etr_override: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_PHISH_DELIVERED_DUE_TO_AN_ETR_OVERRIDE'],
  },
  office365_phish_delivered_due_to_an_ip_allow_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_PHISH_DELIVERED_DUE_TO_AN_IP_ALLOW_POLICY'],
  },
  office365_remote_code_execution_attempt: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_REMOTE_CODE_EXECUTION_ATTEMPT'],
  },
  office365_suspicious_inbox_manipulation_rule: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SUSPICIOUS_INBOX_MANIPULATION_RULE'],
  },
  office365_traffic_detected_from_ip_addresses_recommended_for_blocking: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_TRAFFIC_DETECTED_FROM_IP_ADDRESSES_RECOMMENDED_FOR_BLOCKING'],
  },
  office365_unusual_volume_of_file_deletion: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UNUSUAL_VOLUME_OF_FILE_DELETION'],
  },
  office365_users_targeted_by_phish_campaigns: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_USERS_TARGETED_BY_PHISH_CAMPAIGNS'],
  },
  office365_failed_user_login_attempt: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_FAILED_USER_LOGIN_ATTEMPT'],
  },
  office365_ergoflex_mail_flow: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ERGOFLEX_MAIL_FLOW'],
  },
  office365_unsanctioned_cloud_app_access_was_blocked: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UNSANCTIONED_CLOUD_APP_ACCESS_WAS_BLOCKED'],
  },
  office365_phishing_attempts: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_PHISHING_ATTEMPTS'],
  },
  office365_sharepointfileoperation_via_previously_unseen_ips: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SHAREPOINTFILEOPERATION_VIA_PREVIOUSLY_UNSEEN_IPS'],
  },
  office365_logon_from_an_outdated_browser: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_LOGON_FROM_AN_OUTDATED_BROWSER'],
  },
  office365_dlpid_number_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DLPID_NUMBER_POLICY'],
  },
  office365_stale_externally_shared_files: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_STALE_EXTERNALLY_SHARED_FILES'],
  },
  office365_uploaded_sensitive_file_to_3rd_party_app_or_service: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UPLOADED_SENSITIVE_FILE_TO_3RD_PARTY_APP_OR_SERVICE'],
  },
  office365_365_mailbox_permissions: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_365_MAILBOX_PERMISSIONS'],
  },
  office365_user_requested_to_release_a_quarantined_message: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_USER_REQUESTED_TO_RELEASE_A_QUARANTINED_MESSAGE'],
  },
  office365_granted_access_to_another_mailbox: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_GRANTED_ACCESS_TO_ANOTHER_MAILBOX'],
  },
  office365_shared_folder_document_outside: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SHARED_FOLDER_DOCUMENT_OUTSIDE'],
  },
  office365_shared_file_externally: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SHARED_FILE_EXTERNALLY'],
  },
  office365_granted_mailbox_permission: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_GRANTED_MAILBOX_PERMISSION'],
  },
  office365_new_application_added: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_NEW_APPLICATION_ADDED'],
  },
  office365_suspicious_email_sending_patterns_detected: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SUSPICIOUS_EMAIL_SENDING_PATTERNS_DETECTED'],
  },
  office365_activity_from_a_passwordspray_associated_ip_address: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ACTIVITY_FROM_A_PASSWORDSPRAY_ASSOCIATED_IP_ADDRESS'],
  },
  office365_privileged_accounts__sign_in_failure_spikes: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_PRIVILEGED_ACCOUNTS__SIGN_IN_FAILURE_SPIKES'],
  },
  office365_rare_application_consent: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_RARE_APPLICATION_CONSENT'],
  },
  office365_rare_and_potentially_highrisk_office_operations: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_RARE_AND_POTENTIALLY_HIGHRISK_OFFICE_OPERATIONS'],
  },
  office365_attempt_to_bypass_conditional_access_rule_in_azure_ad: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ATTEMPT_TO_BYPASS_CONDITIONAL_ACCESS_RULE_IN_AZURE_AD'],
  },
  office365_external_shared_file: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_EXTERNAL_SHARED_FILE'],
  },
  office365_admin_compromised: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ADMIN_COMPROMISED'],
  },
  office365_token_issuer: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_TOKEN_ISSUER'],
  },
  office365_new_app_with_score_04_: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_NEW_APP_WITH_SCORE_04_'],
  },
  office365_leaked_creds: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_LEAKED_CREDS'],
  },
  office365_azure_threat_intel: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_AZURE_THREAT_INTEL'],
  },
  office365_malicious_ip: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MALICIOUS_IP'],
  },
  office365_additional_risk_detect: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ADDITIONAL_RISK_DETECT'],
  },
  office365_a_potentially_malicious_url_click_was_detected: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_A_POTENTIALLY_MALICIOUS_URL_CLICK_WAS_DETECTED'],
  },
  office365_tenant_allowblock_list_entry_is_about_to_expire: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_TENANT_ALLOWBLOCK_LIST_ENTRY_IS_ABOUT_TO_EXPIRE'],
  },
  office365_unusual_addition_of_credentials_to_an_oauth_app: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UNUSUAL_ADDITION_OF_CREDENTIALS_TO_AN_OAUTH_APP'],
  },
  office365_elevation_of_exchange_admin_privilege: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_ELEVATION_OF_EXCHANGE_ADMIN_PRIVILEGE'],
  },
  office365_suspicious_sequence_of_exploration_activities: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SUSPICIOUS_SEQUENCE_OF_EXPLORATION_ACTIVITIES'],
  },
  office365_user_restricted_from_sending_email: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_USER_RESTRICTED_FROM_SENDING_EMAIL'],
  },
  office365_multiple_failed_login_attempts: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_MULTIPLE_FAILED_LOGIN_ATTEMPTS'],
  },
  office365_a_user_clicked_through_to_a_potentially_malicious_url: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_A_USER_CLICKED_THROUGH_TO_A_POTENTIALLY_MALICIOUS_URL'],
  },
  office365_suspicious_authentication_activity: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SUSPICIOUS_AUTHENTICATION_ACTIVITY'],
  },
  office365_ipcrisk_signin_inside_country: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_IPCRISK_SIGNIN_INSIDE_COUNTRY'],
  },
  office365_ipcrisk_signin_outside_country: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_IPCRISK_SIGNIN_OUTSIDE_COUNTRY'],
  },
  office365_directoryaudit_consent_to_application: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_CONSENT_TO_APPLICATION'],
  },
  office365_directoryaudit_reset_user_password: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_RESET_USER_PASSWORD'],
  },
  office365_directoryaudit_reset_password_by_admin: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_RESET_PASSWORD_BY_ADMIN'],
  },
  office365_directoryaudit_add_conditional_access_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_CONDITIONAL_ACCESS_POLICY'],
  },
  office365_directoryaudit_delete_conditional_access_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_DELETE_CONDITIONAL_ACCESS_POLICY'],
  },
  office365_posture_admin_mfa: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTURE_ADMIN_MFA'],
  },
  office365_posture_user_mfa: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTURE_USER_MFA'],
  },
  office365_posture_new_admin_user_without_mfa: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTURE_NEW_ADMIN_USER_WITHOUT_MFA'],
  },
  office365_posture_user_application_consent: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTURE_USER_APPLICATION_CONSENT'],
  },
  office365_posture_block_legacy_auth: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTURE_BLOCK_LEGACY_AUTH'],
  },
  office365_posture_inactive_accounts: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTURE_INACTIVE_ACCOUNTS'],
  },
  office365_directoryaudit_add_app_role_assignment_grant_to_user: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_APP_ROLE_ASSIGNMENT_GRANT_TO_USER'],
  },
  office365_directoryaudit_add_app_role_assignment_to_service_principal: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_APP_ROLE_ASSIGNMENT_TO_SERVICE_PRINCIPAL'],
  },
  office365_directoryaudit_add_application: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_APPLICATION'],
  },
  office365_directoryaudit_add_delegated_permission_grant: {
    message: language['THREAT_ALERTS.ALERT_TYPE.office365_DIRECTORYAUDIT_ADD_DELEGATED_PERMISSION_GRANT'],
  },
  office365_directoryaudit_add_device: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_DEVICE'],
  },
  office365_directoryaudit_add_owner: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_OWNER'],
  },
  office365_directoryaudit_add_service_principal: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_SERVICE_PRINCIPAL'],
  },
  office365_directoryaudit_add_service_principal_credentials: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_SERVICE_PRINCIPAL_CREDENTIALS'],
  },
  office365_directoryaudit_add_user: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_USER'],
  },
  office365_directoryaudit_admin_deleted_security_info: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADMIN_DELETED_SECURITY_INFO'],
  },
  office365_directoryaudit_admin_registered_security_info: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADMIN_REGISTERED_SECURITY_INFO'],
  },
  office365_directoryaudit_user_registered_security_info: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_USER_REGISTERED_SECURITY_INFO'],
  },
  office365_directoryaudit_user_registered_security_info_inside_safe_country: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_USER_REGISTERED_SECURITY_INFO_INSIDE_COUNTRY'],
  },
  office365_directoryaudit_admin_registered_security_info_inside_safe_country: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADMIN_REGISTERED_SECURITY_INFO_INSIDE_COUNTRY'],
  },
  office365_directoryaudit_user_registered_security_info_outside_safe_country: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_USER_REGISTERED_SECURITY_INFO_OUTSIDE_COUNTRY'],
  },
  office365_directoryaudit_admin_registered_security_info_outside_safe_country: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADMIN_REGISTERED_SECURITY_INFO_OUTSIDE_COUNTRY'],
  },
  office365_directoryaudit_user_registered_additional_security_info_inside_of_safe_country: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_USER_REGISTERED_ADDITIONAL_SECURITY_INFO_INSIDE_COUNTRY'
      ],
  },
  office365_directoryaudit_admin_registered_additional_security_info_inside_of_safe_country: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADMIN_REGISTERED_ADDITIONAL_SECURITY_INFO_INSIDE_COUNTRY'
      ],
  },
  office365_directoryaudit_user_registered_additional_security_info_outside_of_safe_country: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_USER_REGISTERED_ADDITIONAL_SECURITY_INFO_OUTSIDE_COUNTRY'
      ],
  },
  office365_directoryaudit_admin_registered_additional_security_info_outside_of_safe_country: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADMIN_REGISTERED_ADDITIONAL_SECURITY_INFO_OUTSIDE_COUNTRY'
      ],
  },
  office365_directoryaudit_registered_security_info_from_unknown_location: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_REGISTERED_SECURITY_INFO_WITH_UNKOWN_LOCATION'],
  },
  office365_directoryaudit_change_password_selfservice: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_CHANGE_PASSWORD_SELFSERVICE'],
  },
  office365_directoryaudit_change_user_license: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_CHANGE_USER_LICENSE'],
  },
  office365_directoryaudit_change_user_password: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_CHANGE_USER_PASSWORD'],
  },
  office365_directoryaudit_device_no_longer_compliant: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_DEVICE_NO_LONGER_COMPLIANT'],
  },
  office365_directoryaudit_device_no_longer_managed: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_DEVICE_NO_LONGER_MANAGED'],
  },
  office365_directoryaudit_enable_account: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ENABLE_ACCOUNT'],
  },
  office365_directoryaudit_disable_account: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_DISABLE_ACCOUNT'],
  },
  office365_directoryaudit_invite_external_user: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_INVITE_EXTERNAL_USER'],
  },
  office365_directoryaudit_redeem_external_user_invite: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_REDEEM_EXTERNAL_USER_INVITE'],
  },
  office365_directoryaudit_register_device: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_REGISTER_DEVICE'],
  },
  office365_directoryaudit_remove_delegated_permission_grant: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_REMOVE_DELEGATED_PERMISSION_GRANT'],
  },
  office365_directoryaudit_remove_member_from_group: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_REMOVE_MEMBER_FROM_GROUP'],
  },
  office365_directoryaudit_remove_owner_from_group: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_REMOVE_OWNER_FROM_GROUP'],
  },
  office365_directoryaudit_reset_password_selfservice: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_RESET_PASSWORD_SELFSERVICE'],
  },
  office365_directoryaudit_update_application: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_UPDATE_APPLICATION'],
  },
  office365_directoryaudit_update_application_certificates_and_secrets_management: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_UPDATE_APPLICATION_CERTIFICATES_AND_SECRETS_MANAGEMENT'
      ],
  },
  office365_directoryaudit_update_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_UPDATE_POLICY'],
  },
  office365_directoryaudit_update_service_principal: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_UPDATE_SERVICE_PRINCIPAL'],
  },
  office365_directoryaudit_user_changed_default_security_info: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_USER_CHANGED_DEFAULT_SECURITY_INFO'],
  },
  office365_directoryaudit_user_deleted_security_info: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_USER_DELETED_SECURITY_INFO'],
  },
  office365_directoryaudit_disable_strong_authentication: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_DISABLE_STRONG_AUTHENTICATION'],
  },
  office365_directoryaudit_set_verified_publisher: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_SET_VERIFIED_PUBLISHER'],
  },
  office365_directoryaudit_admin_role_assigned: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADMIN_ROLE_ASSIGNED'],
  },
  office365_directoryaudit_add_member_to_role_outside_of_pim: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_MEMBER_TO_ROLE_OUTSIDE_OF_PIM'],
  },
  office365_directoryaudit_delete_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_DELETE_POLICY'],
  },
  office365_directoryaudit_update_conditional_access_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_UPDATE_CONDITIONAL_ACCESS_POLICY'],
  },
  office365_directoryaudit_update_authorization_policy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_UPDATE_AUTHORIZATION_POLICY'],
  },
  office365_directoryaudit_update_role: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_UPDATE_ROLE'],
  },
  office365_directoryaudit_add_a_partner_to_cross_tenant_access_setting: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_ADD_A_PARTNER_TO_CROSS_TENANT_ACCESS_SETTING'],
  },
  office365_directoryaudit_triggered_pim_alert: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_DIRECTORYAUDIT_TRIGGERED_PIM_ALERT'],
  },
  office365_ualrule_successful_signin_outside_country_from_bad_country_list: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_SUCCESSFUL_SIGNIN_OUTSIDE_COUNTRY_FROM_BAD_COUNTRY_LIST'],
  },
  office365_ualrule_failed_signin_outside_country_from_bad_country_list: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_FAILED_SIGNIN_OUTSIDE_COUNTRY_FROM_BAD_COUNTRY_LIST'],
  },
  office365_ualrule_three_failed_signin_attempts_from_outside_operating_country: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_THREE_FAILED_SIGNIN_ATTEMPTS_FROM_OUTSIDE_OPERATING_COUNTRY'
      ],
  },
  office365_ualrule_five_failed_signin_attempts_from_outside_operating_country: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_FIVE_FAILED_SIGNIN_ATTEMPTS_FROM_OUTSIDE_OPERATING_COUNTRY'],
  },
  office365_ualrule_successful_signin_from_outside_operating_country: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_SUCCESSFUL_SIGNIN_FROM_OUTSIDE_OPERATING_COUNTRY'],
  },
  office365_ualrule_successful_signin_from_unidentifiable_location_or_ip: {
    message:
      language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_SUCCESSFUL_SIGNIN_FROM_UNIDENTIFIABLE_LOCATION_OR_IP'],
  },
  office365_ualrule_new_inbox_rule: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_NEW_INBOX_RULE'],
  },
  office365_ualrule_new_inbox_rule_is_created_that_forwards_emails_to_the_rss_folder: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_NEW_INBOX_RULE_IS_CREATED_THAT_FORWARDS_EMAILS_TO_THE_RSS_FOLDER'
      ],
  },
  office365_ualrule_new_inbox_rule_is_created_that_forwards_emails_to_a_different_email_address: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_NEW_INBOX_RULE_IS_CREATED_THAT_FORWARDS_EMAILS_TO_A_DIFFERENT_EMAIL_ADDRESS'
      ],
  },
  office365_ualrule_new_inbox_rule_is_created_that_redirects_emails_to_a_different_email_address: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_NEW_INBOX_RULE_IS_CREATED_THAT_REDIRECTS_EMAILS_TO_A_DIFFERENT_EMAIL_ADDRESS'
      ],
  },
  office365_ualrule_new_inbox_rule_is_created_with_suspicious_rule_name: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_NEW_INBOX_RULE_IS_CREATED_WITH_SUSPICIOUS_RULE_NAME'],
  },
  office365_ualrule_inbox_rule_is_created_that_deletes_emails: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_INBOX_RULE_IS_CREATED_THAT_DELETES_EMAILS'],
  },
  office365_ualrule_set_inbox_rule: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_SET_INBOX_RULE'],
  },
  office365_ualrule_set_inbox_rule_is_created_that_forwards_emails_to_the_rss_folder: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_UALRULE_SET_INBOX_RULE_IS_CREATED_THAT_FORWARDS_EMAILS_TO_THE_RSS_FOLDER'
      ],
  },
  office365_ualrule_set_inbox_rule_is_created_that_forwards_emails_to_a_different_email_address: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_SET_INBOX_RULE_IS_CREATED_THAT_FORWARDS_EMAILS_TO_A_DIFFERENT_EMAIL_ADDRESS'
      ],
  },
  office365_ualrule_set_inbox_rule_is_created_that_redirects_emails_to_a_different_email_address: {
    message:
      language[
        'THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_SET_INBOX_RULE_IS_CREATED_THAT_REDIRECTS_EMAILS_TO_A_DIFFERENT_EMAIL_ADDRESS'
      ],
  },
  office365_ualrule_set_inbox_rule_is_created_with_suspicious_rule_name: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_UALRULE_SET_INBOX_RULE_IS_CREATED_WITH_SUSPICIOUS_RULE_NAME'],
  },
  office365_posturedrift_cisa_ms_aad_2_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_2_1'],
  },
  office365_posturedrift_cisa_ms_aad_2_3: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_2_3'],
  },
  office365_posturedrift_cisa_ms_aad_3_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_3_1'],
  },
  office365_posturedrift_cisa_ms_aad_3_3: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_3_3'],
  },
  office365_posturedrift_cisa_ms_aad_3_5: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_3_5'],
  },
  office365_posturedrift_cisa_ms_aad_3_6: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_3_6'],
  },
  office365_posturedrift_cisa_ms_aad_3_7: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_3_7'],
  },
  office365_posturedrift_cisa_ms_aad_3_8: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_3_8'],
  },
  office365_posturedrift_cisa_ms_aad_5_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_5_1'],
  },
  office365_posturedrift_cisa_ms_aad_5_3: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_5_3'],
  },
  office365_posturedrift_cisa_ms_aad_6_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_6_1'],
  },
  office365_posturedrift_cisa_ms_aad_7_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_7_1'],
  },
  office365_posturedrift_cisa_ms_aad_7_2: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_7_2'],
  },
  office365_posturedrift_cisa_ms_aad_7_3: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_7_3'],
  },
  office365_posturedrift_cisa_ms_aad_7_4: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_7_4'],
  },
  office365_posturedrift_cisa_ms_aad_7_5: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_7_5'],
  },
  office365_posturedrift_cisa_ms_aad_7_6: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_7_6'],
  },
  office365_posturedrift_cisa_ms_aad_8_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_8_1'],
  },
  office365_posturedrift_cisa_ms_aad_8_2: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_AAD_8_2'],
  },
  office365_posturedrift_cisa_ms_exo_12_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_12_1'],
  },
  office365_posturedrift_cisa_ms_exo_12_2: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_12_2'],
  },
  office365_posturedrift_cisa_ms_exo_2_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_2_1'],
  },
  office365_posturedrift_cisa_ms_exo_2_2: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_2_2'],
  },
  office365_posturedrift_cisa_ms_exo_4_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_4_1'],
  },
  office365_posturedrift_cisa_ms_exo_4_2: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_4_2'],
  },
  office365_posturedrift_cisa_ms_exo_4_3: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_4_3'],
  },
  office365_posturedrift_cisa_ms_exo_5_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_5_1'],
  },
  office365_posturedrift_cisa_ms_exo_6_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_6_1'],
  },
  office365_posturedrift_cisa_ms_exo_6_2: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_6_2'],
  },
  office365_posturedrift_cisa_ms_exo_7_1: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CISA_MS_EXO_7_1'],
  },
  office365_posturedrift_eidsca_af01: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AF01'],
  },
  office365_posturedrift_eidsca_af02: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AF02'],
  },
  office365_posturedrift_eidsca_ag02: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AG02'],
  },
  office365_posturedrift_eidsca_am06: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AM06'],
  },
  office365_posturedrift_eidsca_am09: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AM09'],
  },
  office365_posturedrift_eidsca_ap07: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AP07'],
  },
  office365_posturedrift_eidsca_ap08: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AP08'],
  },
  office365_posturedrift_eidsca_ap09: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AP09'],
  },
  office365_posturedrift_eidsca_ap10: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AP10'],
  },
  office365_posturedrift_eidsca_ap14: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AP14'],
  },
  office365_posturedrift_eidsca_at02: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AT02'],
  },
  office365_posturedrift_eidsca_av01: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_AV01'],
  },
  office365_posturedrift_eidsca_cp03: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_CP03'],
  },
  office365_posturedrift_eidsca_cr02: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_CR02'],
  },
  office365_posturedrift_eidsca_cr03: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_CR03'],
  },
  office365_posturedrift_eidsca_cr04: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_CR04'],
  },
  office365_posturedrift_eidsca_pr01: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_PR01'],
  },
  office365_posturedrift_eidsca_pr02: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_PR02'],
  },
  office365_posturedrift_eidsca_pr03: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_PR03'],
  },
  office365_posturedrift_eidsca_pr05: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_PR05'],
  },
  office365_posturedrift_eidsca_pr06: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EIDSCA_PR06'],
  },
  office365_posturedrift_mt_1001: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1001'],
  },
  office365_posturedrift_mt_1002: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1002'],
  },
  office365_posturedrift_mt_1003: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1003'],
  },
  office365_posturedrift_mt_1004: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1004'],
  },
  office365_posturedrift_mt_1005: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1005'],
  },
  office365_posturedrift_mt_1011: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1011'],
  },
  office365_posturedrift_mt_1013: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1013'],
  },
  office365_posturedrift_mt_1014: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1014'],
  },
  office365_posturedrift_mt_1015: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1015'],
  },
  office365_posturedrift_mt_1017: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1017'],
  },
  office365_posturedrift_mt_1018: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1018'],
  },
  office365_posturedrift_mt_1019: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1019'],
  },
  office365_posturedrift_mt_1020: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1020'],
  },
  office365_posturedrift_mt_1022: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1022'],
  },
  office365_posturedrift_mt_1023: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1023'],
  },
  office365_posturedrift_mt_1026: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1026'],
  },
  office365_posturedrift_mt_1030: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1030'],
  },
  office365_posturedrift_mt_1031: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MT_1031'],
  },
  office365_posturedrift_activitybasedtimeoutpolicy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_ACTIVITYBASEDTIMEOUTPOLICY'],
  },
  office365_posturedrift_blocksigninsharedmailboxes: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_BLOCKSIGNINSHAREDMAILBOXES'],
  },
  office365_posturedrift_connectedappsadminconsent: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CONNECTEDAPPSADMINCONSENT'],
  },
  office365_posturedrift_contactsettings: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_CONTACTSETTINGS'],
  },
  office365_posturedrift_deleteduseronedriveretention: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_DELETEDUSERONEDRIVERETENTION'],
  },
  office365_posturedrift_dkim: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_DKIM'],
  },
  office365_posturedrift_enableexchangemodernauth: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_ENABLEEXCHANGEMODERNAUTH'],
  },
  office365_posturedrift_entraidguestuseraccesspermissions: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_ENTRAIDGUESTUSERACCESSPERMISSIONS'],
  },
  office365_posturedrift_externalmailtag: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_EXTERNALMAILTAG'],
  },
  office365_posturedrift_loginportalbranding: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_LOGINPORTALBRANDING'],
  },
  office365_posturedrift_mailboxaudit: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MAILBOXAUDIT'],
  },
  office365_posturedrift_mdo_allowedsenderscombined: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ALLOWEDSENDERSCOMBINED'],
  },
  office365_posturedrift_mdo_antiphishingpolicies: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ANTIPHISHINGPOLICIES'],
  },
  office365_posturedrift_mdo_atpprotection: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ATPPROTECTION'],
  },
  office365_posturedrift_mdo_autoforwardingmode: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_AUTOFORWARDINGMODE'],
  },
  office365_posturedrift_mdo_blockmailforward: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_BLOCKMAILFORWARD'],
  },
  office365_posturedrift_mdo_bulkspamaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_BULKSPAMACTION'],
  },
  office365_posturedrift_mdo_bulkthreshold: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_BULKTHRESHOLD'],
  },
  office365_posturedrift_mdo_commonattachmentsfilter: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_COMMONATTACHMENTSFILTER'],
  },
  office365_posturedrift_mdo_connectionfilter: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_CONNECTIONFILTER'],
  },
  office365_posturedrift_aug_cis_m365_2_1_13: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_AUG_CIS_M365_2_1_13'],
  },
  office365_posturedrift_mdo_enabledomainstoprotect: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ENABLEDOMAINSTOPROTECT'],
  },
  office365_posturedrift_mdo_enablemailboxintelligence: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ENABLEMAILBOXINTELLIGENCE'],
  },
  office365_posturedrift_mdo_highconfidencephishaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_HIGHCONFIDENCEPHISHACTION'],
  },
  office365_posturedrift_mdo_highconfidencespamaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_HIGHCONFIDENCESPAMACTION'],
  },
  office365_posturedrift_mdo_mailboxintelligenceprotection: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_MAILBOXINTELLIGENCEPROTECTION'],
  },
  office365_posturedrift_mdo_mailboxintelligenceprotectionaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_MAILBOXINTELLIGENCEPROTECTIONACTION'],
  },
  office365_posturedrift_mdo_phishthresholdlevel: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_PHISHTHRESHOLDLEVEL'],
  },
  office365_posturedrift_mdo_phisspamacation: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_PHISSPAMACATION'],
  },
  office365_posturedrift_mdo_quarantineretentionperiod: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_QUARANTINERETENTIONPERIOD'],
  },
  office365_posturedrift_mdo_recipientexternallimitperhour: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_RECIPIENTEXTERNALLIMITPERHOUR'],
  },
  office365_posturedrift_mdo_recipientinternallimitperhour: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_RECIPIENTINTERNALLIMITPERHOUR'],
  },
  office365_posturedrift_mdo_recipientlimitperday: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_RECIPIENTLIMITPERDAY'],
  },
  office365_posturedrift_mdo_safeattachmentpolicy: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SAFEATTACHMENTPOLICY'],
  },
  office365_posturedrift_mdo_safeattachments: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SAFEATTACHMENTS'],
  },
  office365_posturedrift_mdo_safedocuments: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SAFEDOCUMENTS'],
  },
  office365_posturedrift_mdo_safelinksforofficeapps: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SAFELINKSFOROFFICEAPPS'],
  },
  office365_posturedrift_mdo_safelinksforemail: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SAFELINKSFOREMAIL'],
  },
  office365_posturedrift_mdo_similardomainssafetytips: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SIMILARDOMAINSSAFETYTIPS'],
  },
  office365_posturedrift_mdo_similaruserssafetytips: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SIMILARUSERSSAFETYTIPS'],
  },
  office365_posturedrift_mdo_spam_notifications_only_for_admins: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SPAM_NOTIFICATIONS_ONLY_FOR_ADMINS'],
  },
  office365_posturedrift_mdo_spamaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_SPAMACTION'],
  },
  office365_posturedrift_mdo_targeteddomainprotectionaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_TARGETEDDOMAINPROTECTIONACTION'],
  },
  office365_posturedrift_mdo_targeteduserprotectionaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_TARGETEDUSERPROTECTIONACTION'],
  },
  office365_posturedrift_mdo_targetedusersprotection: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_TARGETEDUSERSPROTECTION'],
  },
  office365_posturedrift_mdo_thresholdreachedaction: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_THRESHOLDREACHEDACTION'],
  },
  office365_posturedrift_mdo_unusualcharacterssafetytips: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_UNUSUALCHARACTERSSAFETYTIPS'],
  },
  office365_posturedrift_mdo_zapmalware: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ZAPMALWARE'],
  },
  office365_posturedrift_mdo_zapphish: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ZAPPHISH'],
  },
  office365_posturedrift_mdo_zapspam: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MDO_ZAPSPAM'],
  },
  office365_posturedrift_mfacampaign: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MFACAMPAIGN'],
  },
  office365_posturedrift_mfanumbermatching: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_MFANUMBERMATCHING'],
  },
  office365_posturedrift_powershellaccessfornonadmins: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_POWERSHELLACCESSFORNONADMINS'],
  },
  office365_posturedrift_resharingbyexternalusers: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_RESHARINGBYEXTERNALUSERS'],
  },
  office365_posturedrift_riskycountries: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_RISKYCOUNTRIES'],
  },
  office365_posturedrift_riskyips: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_RISKYIPS'],
  },
  office365_posturedrift_selfservepasswordreset: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_SELFSERVEPASSWORDRESET'],
  },
  office365_posturedrift_sharepointexternalguestsharing: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_SHAREPOINTEXTERNALGUESTSHARING'],
  },
  office365_posturedrift_sitecreationforstandardusers: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_SITECREATIONFORSTANDARDUSERS'],
  },
  office365_posturedrift_teamsdefaultexternaloptions: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_TEAMSDEFAULTEXTERNALOPTIONS'],
  },
  office365_posturedrift_temporaryaccesspass: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_TEMPORARYACCESSPASS'],
  },
  office365_posturedrift_unifiedauditlog: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_UNIFIEDAUDITLOG'],
  },
  office365_posturedrift_rejectdirectsend: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_POSTUREDRIFT_REJECTDIRECTSEND'],
  },
  office365_scheduled_actions_offboarding_success_alerts: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SCHEDULED_ACTIONS_OFFBOARDING_SUCCESS_ALERTS'],
  },
  office365_scheduled_actions_offboarding_failure_alerts: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_SCHEDULED_ACTIONS_OFFBOARDING_FAILURE_ALERTS'],
  },
  office365_m365_integration_has_disconnected: {
    message: language['THREAT_ALERTS.ALERT_TYPE.OFFICE365_M365_INTEGRATION_HAS_DISCONNECTED'],
  },
}
